// extracted by mini-css-extract-plugin
export default {"icon":"after-delete-account_icon__XMiJY"};